/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_View_WaistInputs */

const en_platform_view_waist = /** @type {(inputs: Platform_View_WaistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waist`)
};

const pl_platform_view_waist = /** @type {(inputs: Platform_View_WaistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talia`)
};

/**
* | output |
* | --- |
* | "Waist" |
*
* @param {Platform_View_WaistInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_view_waist = /** @type {((inputs?: Platform_View_WaistInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_View_WaistInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_view_waist(inputs)
	return en_platform_view_waist(inputs)
});